import {inject, injectable} from 'inversify';

import type {
  ApiListResponseExpanded,
  ApiMethodName,
} from '../../../../../api/types';
import type {CoreUserWaitlistItemsListParams} from '../../../../../api/types/core/methods';
import type {FetchUserWaitlistItemsQuery} from '../FetchUserWaitlistItems.query';

import {apiRequest} from '../../../../../api/utils/apiRequest';
import {WaitlistItemMapperJrpc} from '../../../../domain/WaitlistItem/mappers/WaitlistItem.mapper.jrpc';

@injectable()
export class FetchUserWaitlistItemsQueryJrpc
  implements FetchUserWaitlistItemsQuery
{
  constructor(
    @inject(WaitlistItemMapperJrpc)
    private readonly mapper: WaitlistItemMapperJrpc,
  ) {}

  async fetch(): Promise<FetchUserWaitlistItemsQuery.Response> {
    const expand = this.mapper.expand.getByEnv();

    const method: ApiMethodName = 'user.waitlist_items.list';

    const params: CoreUserWaitlistItemsListParams = {
      expand,
      query: [['joined_on', '==', null]],
      sort: [['created', -1]],
    };

    const response: ApiListResponseExpanded<WaitlistItemMapperJrpc.ApiData> =
      await apiRequest<typeof params>({
        method,
        params,
      });

    const expanded =
      response._items.map<WaitlistItemMapperJrpc.ExpandedApiData>(item =>
        this.mapper.expand.expandObj(item, {
          expand,
          expanded: response._expanded,
        }),
      );

    return expanded.map(item => this.mapper.mapDataToModel(item));
  }
}
